// extracted by mini-css-extract-plugin
export default {"container":"paymentClaim_container__+a7bB","spinner":"paymentClaim_spinner__o40fm"};